import React, { useMemo } from 'react';
import { Tooltip } from 'antd';
import { AiFillQuestionCircle } from 'react-icons/ai';
import LoadingAvatar from '../../../components/LoadingAvatar';
import { LOADING_BLUE } from '../../../utils/colorCode';
import {
  ReviewDivider,
  ReviewDoubleRow,
  ReviewItem,
  ReviewItemLabel,
  ReviewItemValue,
  ReviewSection,
  ReviewSectionTitle
} from '../../../components/WizardV2/wizardStylesV2';
import { formatBookingCostBreakdownDisplay } from './bookingPaymentBreakdownHelpers';

function LabelQuestionTooltip({ title }) {
  if (!title) return null;
  return (
    <Tooltip title={title}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          marginLeft: 4,
          cursor: 'pointer',
          verticalAlign: 'middle'
        }}>
        <AiFillQuestionCircle color="#3f95e0" />
      </span>
    </Tooltip>
  );
}

function BookingPaymentBreakdownV2({ t, breakdown, paymentDetails, loading = false, error = null }) {
  const display = useMemo(
    () =>
      breakdown ? formatBookingCostBreakdownDisplay(breakdown, t, paymentDetails) : null,
    [breakdown, paymentDetails, t]
  );

  if (loading) {
    return (
      <>
        <ReviewDivider />
        <ReviewSection>
          <ReviewSectionTitle>{t('Payment', { defaultValue: 'Payment' })}</ReviewSectionTitle>
          <LoadingAvatar color={LOADING_BLUE} />
        </ReviewSection>
      </>
    );
  }

  if (error || !display) {
    return null;
  }

  return (
    <>
      <ReviewDivider />
      <ReviewSection>
        <ReviewSectionTitle>{t('Payment', { defaultValue: 'Payment' })}</ReviewSectionTitle>
        <ReviewDoubleRow>
          <ReviewItem>
            <ReviewItemLabel style={{ display: 'flex', alignItems: 'center' }}>
              {t('add_amenity_booking_fee', { defaultValue: 'Booking Fee' })}
              <LabelQuestionTooltip title={display.bookingFeeTooltip} />
            </ReviewItemLabel>
            <ReviewItemValue>{display.bookingFee}</ReviewItemValue>
          </ReviewItem>
          <ReviewItem>
            <ReviewItemLabel style={{ display: 'flex', alignItems: 'center' }}>
              {t('add_amenity_review_service_fee_label', { defaultValue: 'Service Fee' })}
              <LabelQuestionTooltip title={display.serviceFeeTooltip} />
            </ReviewItemLabel>
            <ReviewItemValue>{display.serviceFee}</ReviewItemValue>
          </ReviewItem>
        </ReviewDoubleRow>
        <ReviewDoubleRow>
          <ReviewItem>
            <ReviewItemLabel>
              {t('add_amenity_review_deposit_label', { defaultValue: 'Deposit' })}
            </ReviewItemLabel>
            <ReviewItemValue>{display.deposit}</ReviewItemValue>
          </ReviewItem>
          <ReviewItem>
            <ReviewItemLabel>
              {t('add_amenity_review_processing_fee_label', {
                defaultValue: 'Processing Fee'
              })}
            </ReviewItemLabel>
            <ReviewItemValue>{display.processingFee}</ReviewItemValue>
          </ReviewItem>
        </ReviewDoubleRow>
        <ReviewDoubleRow>
          <ReviewItem>
            <ReviewItemLabel>{t('Subtotal', { defaultValue: 'Subtotal' })}</ReviewItemLabel>
            <ReviewItemValue>{display.subtotal}</ReviewItemValue>
          </ReviewItem>
          <ReviewItem>
            <ReviewItemLabel>{t('Total', { defaultValue: 'Total' })}</ReviewItemLabel>
            <ReviewItemValue>{display.total}</ReviewItemValue>
          </ReviewItem>
        </ReviewDoubleRow>
      </ReviewSection>
    </>
  );
}

export default BookingPaymentBreakdownV2;
